module.exports = __webpack_public_path__ + "static/img/grongnoi_mee_gunjae_mee_akegasan.72e616d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/grongnoi_mee_gunjae_mee_akegasan.png
// module id = uEPO
// module chunks = 134